<template>
  <div id="app">
    <!-- <div class = "fb-customerchat"
    page_id = "204099662881"
    theme_color = "#459645"
    logged_in_greeting = "Hi! How can we help you?"
    logged_out_greeting = "Bye Bye"
    minimized = "false"
    >

    </div> -->
    <div class="nav-fixed">
      <Navbar/>
    </div>
    <div class="bg1"></div>
    <div id="fb-root"></div>
    <div class="fb-customerchat"
        attribution=setup_tool
        page_id="204099662881"
        theme_color="#0084ff"
        logged_in_greeting="Hi MISA applicant! How can we help you? :)"
        logged_out_greeting="Hi MISA applicant! How can we help you? :)">
    </div>
    <div class="container">
      <!-- This is where the views are rendered (on rails, its Yield) -->
      <router-view/>
    </div>
  </div>
</template>

<script>
  import Navbar from './components/Navbar.vue'
export default {
  components: {
    Navbar,
  },
  mounted(){

    window.fbAsyncInit = function() {
          window.FB.init({
            appId : '963184580781236',
            autoLogAppEvents : true,
            xfbml : true,
            version : 'v7.0'
          });
        };

        (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js#xfbml=1&version=v2.12&autoLogAppEvents=1';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));

      document.getElementById("logo").click();
      console.log("test mounted");
  
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  position: fixed;
  top:0;
  left:0;
  bottom:0;
  right:0;
  overflow: auto;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  overflow-x: hidden;

  scroll-behavior: smooth;
  scroll-snap-type: y mandatory;
}

b {
  font-weight: 600;
}


.nav-fixed{
  position: fixed;
  width: 100vw;
  background-color: white;
  z-index: 999;
}

.container{
  top:0;
  left:0;
  bottom:0;
  right:0;
  padding-top: 8vw;
}
button {
  outline: none;
  cursor: pointer;
}

h1, h2, h3, h4, h5, p {
  color: #242424;
  letter-spacing: -0.015em;
}

/* super small phones */
@media only screen and (max-width: 450px) {
  button, a
  {
    font-size: 12px;
  }
}


/* Extra small devices (phones, 600px and down) */
@media only screen and (min-width: 450px) {
  h1{
    font-size: 52.4px;
  }

  h2{
    font-size: 20px;
  }

  h3{
    font-size: 15px;
    font-weight: 300;
  }

  button, a
  {
    font-size: 15px;
  }

  h4{
    font-size: 13px;
  }

  h5{
    font-size: 12px;
  }

  li {
    font-size: 12px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  h1{
    font-size: 58.9px;
  }

  h2{
    font-size: 22.4px;
  }

  h3{
    font-size: 16.8px;
    font-weight: 300;
  }

  button, a
  {
    font-size: 16.8px;
  }

  h4{
    font-size: 14.7px;
  }

  h5{
    font-size: 14px;
  }

  li {
    font-size: 14px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  h1{
    font-size: 66.3px;
  }

  h2{
    font-size: 25.3px;
  }

  h3{
    font-size: 18.9px;
    font-weight: 300;
  }

  button, a
  {
    font-size: 18.9px;
  }

  h4{
    font-size: 16.5px;
  }

  h5{
    font-size: 15.8px;
  }

  li {
    font-size: 15.8px;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  h1{
    font-size: 74.6px;
  }

  h2{
    font-size: 28.4px;
  }

  h3{
    font-size: 21.3px;
    font-weight: 300;
  }

  button, a
  {
    font-size: 21.3px;
  }

  h4{
    font-size: 18.6px;
  }

  h5{
    font-size: 17.7px;
  }

  li {
    font-size: 17.7px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    
  h1{
    font-size: 4.5vw;
  }

  h2{
    font-size: 32px;
  }

  h3{
    font-size: 24px;
    font-weight: 300;
  }

  button, a
  {
    font-size: 24px;
  }

  h4{
    font-size: 21px;
  }

  h5{
    font-size: 18px;
  }

  li {
    font-size: 20px;
  }
}

/* h1{
  font-size: 4.634em;
}

h2{
  font-size: 2.027em;
}

h3{
  font-size: 1.602em;
  font-weight: 300;
}

h4{
  font-size: 1.266em;
}

h5{
  font-size: 1.125em;
}

li {
  font-size: 1.125em;
}

p{
  font-size: 1em;
} */

.primary-btn{
  color: white;
  background: #31A5AF;
  mix-blend-mode: normal;
  border: 2px solid #31A5AF;
  box-sizing: border-box;
  border-radius: 0.6em;
}

.primary-btn:hover {
  background: #242424;
  border-color: #242424;
  color: white;
}

.secondary-btn{
  background-color: #FFFFFF;
  border: 3px solid #31A5AF;
  box-sizing: border-box;
  border-radius: 0.6em;
  color: #31A5AF;
  /* font-size: 12px; */
}

.secondary-btn:hover{
  background: #31A5AF;
  color: white;
}

.secondaty-btn-active{
  background: #31A5AF;
  color: white;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

</style>
